import { render } from "./AproposView.vue?vue&type=template&id=1b65f9e4"
import script from "./AproposView.vue?vue&type=script&lang=js"
export * from "./AproposView.vue?vue&type=script&lang=js"

import "./AproposView.vue?vue&type=style&index=0&id=1b65f9e4&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__